<div class="sg-dropdown-container" [class.x-small]="size === 'x-small'">
  <mat-form-field
    [subscriptSizing]="subscriptSizing"
    #field
    class="dropdown-wrapper sg-ui-component"
    [floatLabel]="!label?.length ? 'auto' : 'always'"
    [class.has-value]="selectedOption.value || selectedOptions.value?.length > 0"
    [class.small]="size === 'small'"
    [class.no-label]="!label"
    [class.mat-mdc-form-field-disabled]="isDisabled"
    [appearance]="appearance">
    @if (label) {
      <mat-label>
        <span class="label" [class.multi-select]="isMultiSelect">
          @if (labelIcon && !selectedOption.value && selectedOptions.value?.length === 0 && !isOpen) {
            <mat-icon>{{ labelIcon }}</mat-icon>
          }
          <sg-text variant="sg-label-medium-regular">{{ label }}</sg-text>
        </span>
      </mat-label>
    }
    @if (isMultiSelect) {
      <mat-select
        disableOptionCentering
        [panelClass]="panelClasses"
        class="sg-ui-component"
        [formControl]="selectedOptions"
        multiple
        [placeholder]="placeholder"
        (openedChange)="onOpenChange($event)">
        <mat-select-trigger class="sg-ui-component">
          <sg-dropdown-chips-list
            (deselectOptions)="deselectOptions($event)"
            [values]="selectedOptions.value"
            [totalOptions]="totalOptions"></sg-dropdown-chips-list>
        </mat-select-trigger>
        @if (isGrouped) {
          @for (group of normalizedItems; track $index) {
            <mat-optgroup class="sg-ui-component">
              <sg-text class="group-label" variant="sg-body-small-bold">{{ group.label }}</sg-text>
              @for (option of group.options; track $index; let last = $last) {
                <mat-option [class.last-option]="last && showGroupDivider" [value]="option" class="sg-ui-component">
                  <sg-dropdown-option-item
                    [isSelected]="isSelected(option)"
                    [option]="option"
                    [showSelectedIcon]="false"
                    [showCheckbox]="false"></sg-dropdown-option-item>
                </mat-option>
              }
            </mat-optgroup>
          }
        } @else {
          @for (option of normalizedItems[0]?.options; track $index) {
            <mat-option [value]="option" class="sg-ui-component">
              <sg-dropdown-option-item
                [isSelected]="isSelected(option)"
                [option]="option"
                [showSelectedIcon]="false"
                [showCheckbox]="false"></sg-dropdown-option-item>
            </mat-option>
          }
        }
      </mat-select>
    } @else {
      @if (!isMultiSelect) {
        <mat-select
          (openedChange)="onOpenChange($event)"
          disableOptionCentering
          [formControl]="selectedOption"
          [compareWith]="compareOptions"
          [panelClass]="panelClasses"
          class="sg-ui-component">
          <mat-select-trigger class="sg-ui-component sg-body-medium-regular" data-test="selected-value">
            @if (selectedOption.value) {
              <span class="trigger-content" [class.with-icon]="icon" [class.icon-start]="iconPosition === 'start'" [class.icon-end]="iconPosition === 'end'">
                @if (icon && iconPosition === "start") {
                  <mat-icon class="trigger-icon">{{ icon }}</mat-icon>
                }
                <span class="trigger-label">{{ selectedOption.value?.label }}</span>
                @if (icon && iconPosition === "end") {
                  <mat-icon class="trigger-icon">{{ icon }}</mat-icon>
                }
              </span>
            } @else {
              <span class="trigger-placeholder">{{ placeholder }}</span>
            }
          </mat-select-trigger>
          @if (isGrouped) {
            @for (group of normalizedItems; track $index) {
              <mat-optgroup class="sg-ui-component">
                <sg-text class="group-label" variant="sg-body-small-bold">{{ group.label }}</sg-text>
                @for (option of group.options; track $index; let last = $last) {
                  <mat-option
                    class="signal-option sg-ui-component"
                    [class.last-option]="last && showGroupDivider"
                    [value]="option"
                    [attr.data-test]="getOptionDataTest(option)">
                    <sg-dropdown-option-item [isSelected]="isSelected(option)" [option]="option" [showSelectedIcon]="false"></sg-dropdown-option-item>
                  </mat-option>
                }
              </mat-optgroup>
            }
          } @else {
            @for (option of normalizedItems[0]?.options; track $index) {
              <mat-option [value]="option" class="sg-ui-component" [attr.data-test]="getOptionDataTest(option)">
                <sg-dropdown-option-item [isSelected]="isSelected(option)" [option]="option" [showSelectedIcon]="false"></sg-dropdown-option-item>
              </mat-option>
            }
          }
        </mat-select>
      }
    }
    <mat-icon matSuffix class="custom-select-arrow sg-ui-component" [class.open]="isOpen">expand_more</mat-icon>
    @if (!hasError()) {
      <mat-hint class="sg-body-xsmall-regular" [class.disabled]="selectedOptions.disabled || selectedOption.disabled">{{ hint }}</mat-hint>
    }
    @if (hasError()) {
      <mat-error class="sg-body-xsmall-regular">{{ errorText }}</mat-error>
    }
  </mat-form-field>
</div>
